import React, { useEffect, useState } from 'react'
import {
    Box,
    Flex,
    Button,
    FormControl,
    FormLabel,
    Textarea,
    Input,
    Switch,
    Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useToast,
  Text 
  } from "@chakra-ui/react";
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { AiOutlineDown } from 'react-icons/ai';
import { Auth } from './Auth';

const GenerateInvoice = ({ invoiceDetails, onClose1, updateTenureDetailsTable }) => {
    const [existsInvoiceItems, setExistsInvoiceItems] = useState([])
    const [selectedDateData, setSelectedDateData] = useState({})
    const [desError, setDesError] = useState(false)
    const [commentError, setCommentError] = useState(false)
    const [dueDateError, setDueDateError] = useState(false)
    const [showSelectedDateError, setShowSelectedDateError] = useState(false)
    const [invoiceInput, setInvoiceInput] = useState({
        dueDate: "",
        taxAmount: 0,
        taxRate: 0.18,
        isTaxable: true,
        dueDateAmount: 0,
        description: "",
        comment: "",
        startDate: ""
    })
    const [monthToSelect, setMonthToSelect] = useState([])
    const [showSelectedDate, setShowSelectedDate] = useState(false)
    const { id } = useParams()
    const toast = useToast()
    // const currentDate = new Date(selectedDateData?.startDate);

    const invoiceHandler = (e) => {
        const { value , name } = e.target
        setInvoiceInput({
            ...invoiceInput, 
            [name]: value
        })
        console.log(e,'88888888')
    }
   
    // get Invoice all
    useEffect(() => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice?tenureId=${id}`,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': Auth()
              },
          };
          
          axios.request(config)
          .then((response) => {
            setExistsInvoiceItems(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
          
    },[id])

    // existInvoice condition
    useEffect(() => {
        if(existsInvoiceItems.length > 0){
            // setMonthToSelect(invoiceDetails?.tenure?.TenureItem?.filter((x) => existsInvoiceItems?.filter((y) => (y.InvoiceItem.map((z) => z.tenureItemSeqId !== x.tenureItemSeqId )))))
            setMonthToSelect(invoiceDetails?.tenure?.TenureItem?.filter((x) => existsInvoiceItems.every((z) => z.InvoiceItem[0].tenureItemSeqId !== x.tenureItemSeqId)) )
        }else{
            setMonthToSelect(invoiceDetails?.tenure?.TenureItem.filter((x) => x))
        }
    },[invoiceDetails.TenureItem, invoiceDetails.tenure.TenureItem, existsInvoiceItems])

    const generateInvoiceHandler = () => {
        
          if((invoiceInput.description.length !== 0) && (invoiceInput.comment.length !== 0) && showSelectedDate && (invoiceInput.dueDate.length !== 0)){
            
            let data = JSON.stringify({
                "invoiceItems": [
                  {
                    "tenureId": `${id}`,
                    "tenureItemSeqId": Number(selectedDateData.tenureItemSeqId),
                    "orderId": `${selectedDateData.orderId}`,
                    "orderItemSeqId": Number(selectedDateData.orderItemSeqId),
                    "isValid": selectedDateData.isValid,
                    "discount": `${selectedDateData.discount}`,
                    "days": Number(selectedDateData.days),
                    "weeks": Number(selectedDateData.weeks),
                    "months": Number(selectedDateData.months),
                    "years": Number(selectedDateData.years),
                    "startDate": `${selectedDateData.startDate}`,
                    "endDate": `${selectedDateData.endDate}`,
                    "pricePerDay": `${selectedDateData.pricePerDay}`,
                    "pricePerWeek": `${selectedDateData.pricePerWeek}`,
                    "pricePerMonth": `${selectedDateData.pricePerMonth}`,
                    "pricePerYear": `${selectedDateData.pricePerYear}`,
                    "partyId": `${invoiceDetails?.order?.customerPartyId}`,
                    "dueDateAmount": Number(invoiceInput.dueDateAmount),
                    "taxAmount": Number(invoiceInput.taxAmount),
                    "invoiceDate": `${new Date().toISOString()}`
                  }
                ],
                "invoiceMeta": {
                  "isTaxable": invoiceInput.isTaxable,
                  "taxRate": Number(invoiceInput.taxRate),
                  "invoiceTypeId": "TENURE_INVOICE",
                  "statusId": "ISSUED",
                  "invoiceDate": `${new Date().toISOString()}`,
                  "dueDate": `${new Date(invoiceInput.dueDate).toISOString()}`,
                  "description": `${invoiceInput.description}`,
                  "comment": `${invoiceInput.comment}`,
                  "cutOffDate": `${invoiceDetails.tenure.endDate}`
                }
              });
              
              let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice/`,
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': Auth()
                  },
                data : data
              };
          
              
            axios.request(config)
              .then((response) => {
                updateTenureDetailsTable(response.data.id)
                toast({
                    title: 'Invoice Generated',
                    status: 'success',
                    position: 'top',
                    duration: 3000,
                    isClosable: true,
                  })
              })
              .catch((error) => {
                console.log(error)
                toast({
                    title: 'Something went wrong please try again',
                    status: 'error',
                    position: 'top',
                    duration: 3000,
                    isClosable: true,
                  })
              });
    
              onClose1()
              setShowSelectedDate(false)
              setDesError(false)
              setCommentError(false)
              setDueDateError(false)
          }else {
              if(showSelectedDate === false){
                setShowSelectedDateError(true)
                console.log('1')
              }else {
                setShowSelectedDateError(false)
                console.log('5')        
              }

                if(invoiceInput.description.length === 0){
                    setDesError(true)
                    console.log('2')
                }
                if(invoiceInput.comment.length === 0){
                    setCommentError(true)
                    console.log('3')
                }
                if(invoiceInput.dueDate.length === 0){
                    setDueDateError(true)
                    console.log('4')
                }
               
          }
          
    }
   
    // console.log(invoiceInput, '88888888')
    // console.log(selectedDateData, 'invoice input')
    // console.log(monthToSelect, '-----------')
    // // console.log(monthToSelect.filter((x) => ((new Date().getMonth() + 1)) >= (new Date(x.startDate).getMonth() + 1)  ), 'select month')
    // console.log((new Date() >= new Date('2023-06-01T00:00:00.000Z')), 'xxxxxxxxxxxxxxxxxx')


    return (
        <>
            <Box>
                <Flex alignItems={'center'} w={'100%'}>
                    <Menu>
                    <MenuButton as={Button} rightIcon={<AiOutlineDown />}>
                        Select Month
                    </MenuButton>
                    <MenuList>
                    {(monthToSelect.filter((x) =>  (new Date() >= new Date(x.startDate))).length > 0) ? 
                            monthToSelect.filter((x) => (new Date() >= new Date(x.startDate))).map((d, i) => {
                                return (
                                    <MenuItem key={i} value={invoiceInput.startDate} onClick={() => {
                                        setInvoiceInput({
                                            ...invoiceInput, 
                                            startDate: d.startDate
                                        })
                                        setSelectedDateData(d)
                                        setShowSelectedDateError(false)
                                        setShowSelectedDate(true)
                                    }} >{new Date(d.startDate).toLocaleDateString('en-IN')}</MenuItem>
                                )              
                            })
                            :
                            <MenuItem value='option3'>----</MenuItem>
                        }
                    </MenuList>
                    </Menu>
                    {showSelectedDate &&
                    <Text ml={3} color={'green.500'}>{new Date(selectedDateData?.startDate).toLocaleDateString('en-IN') || null}</Text> }
                    {showSelectedDateError &&
                    <Text ml={3} color={'red.500'}>{invoiceDetails.tenure.tenurePeriodId === "WEEKLY" ? 'Please select week' : 'Please select month'}</Text> }
                    
                </Flex>
                {showSelectedDate &&
                <>
                <FormControl mt={1}>
                    <FormLabel>Due Date Amount</FormLabel>
                    <Input type='number' step={'any'} value={invoiceInput.dueDateAmount} name={'dueDateAmount'}  onChange={invoiceHandler}/>
                </FormControl>

                <FormControl mt={1}>
                    <FormLabel>Tax Amount</FormLabel>
                    <Input type='number' step={'any'} name={'taxAmount'} value={invoiceInput.taxAmount}  onChange={invoiceHandler}/>
                </FormControl>

                <FormControl mt={1}>
                    <FormLabel>Tax Rate</FormLabel>
                    <Input type='number' step={'any'} name={'taxRate'} value={invoiceInput.taxRate}  onChange={invoiceHandler}/>
                </FormControl>

                <FormControl display='flex' alignItems='center' my={3}>
                    <FormLabel htmlFor='email-alerts' mb={1}>
                        Taxable
                    </FormLabel>
                    <Switch  name={'isTaxable'} isChecked={invoiceInput.isTaxable} onChange={(e) => {
                        if(!e.target.checked){
                            setInvoiceInput({
                                ...invoiceInput, isTaxable: false
                            })
                        }else{
                            setInvoiceInput({
                                ...invoiceInput, isTaxable: true
                            })
                        }
                    }} />
                </FormControl>
                
                <FormControl mt={1} isInvalid={dueDateError}>
                    <FormLabel>Due Date</FormLabel>
                    {invoiceDetails.tenure.tenurePeriodId !== "WEEKLY" ?
                    <Input type='date' min={new Date(selectedDateData?.startDate).toISOString().split('T')[0]} name={'dueDate'} value={invoiceInput.dueDate} onChange={(e) => {
                        invoiceHandler(e)
                        if(e.target.value.length > 0){
                            setDueDateError(false)
                        }else{
                            setDueDateError(true)
                        }
                        }}/>
                        :
                    <Input type='date' min={new Date(selectedDateData?.startDate).toISOString().split('T')[0]} max={new Date(selectedDateData?.endDate).toISOString().split('T')[0]} name={'dueDate'}value={invoiceInput.dueDate} onChange={(e) => {
                        invoiceHandler(e)
                        if(e.target.value.length > 0){
                            setDueDateError(false)
                        }else{
                            setDueDateError(true)
                        }
                        }}/>    
                    }
                </FormControl>
            
                <FormControl mt={1} isInvalid={desError}>
                    <FormLabel>Description</FormLabel>
                    <Textarea  py={2} px={1}  placeholder='Description' name={'description'} value={invoiceInput.description}  onChange={(e) => {
                        invoiceHandler(e)
                        if(e.target.value.length > 0){
                            setDesError(false)
                        }else{
                            setDesError(true)
                        }
                        }}/>
                </FormControl>

                <FormControl mt={1} isInvalid={commentError}>
                    <FormLabel>Comment</FormLabel>
                    <Textarea  py={2} px={1}  placeholder='Comment' name={'comment'} value={invoiceInput.comment} onChange={(e) => {
                        invoiceHandler(e)
                        if(e.target.value.length > 0){
                            setCommentError(false)
                        }else{
                            setCommentError(true)
                        }
                        }}/>
                </FormControl>
                </>
                    }
            </Box>
            <Flex justifyContent={'flex-end'} mt={3}>
                <Button colorScheme={'red'} mr={3} onClick={onClose1}>Cancel</Button>
                <Button colorScheme={'blue'} isDisabled={!(monthToSelect.filter((x) =>  (new Date() >= new Date(x.startDate))).length > 0)} onClick={generateInvoiceHandler}>Generate</Button>
            </Flex>
        </>
    )
}

export default GenerateInvoice